import { render } from "./DeletarServicoModal.vue?vue&type=template&id=21ca0f69&ts=true"
import script from "./DeletarServicoModal.vue?vue&type=script&lang=ts"
export * from "./DeletarServicoModal.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/camp/Desktop/code-time/acampa-gestao-pra/vuecode/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__